export const GET_PREFERENCES = 'GET_PREFERENCES';
export const SET_PREFERENCES = 'SET_PREFERENCES';
export const UPDATE_PREFERENCES = 'UPDATE_PREFERENCES';
export const GET_SETTINGS = 'GET_SETTINGS';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SEND_CONTACT_FORM = 'SEND_CONTACT_FORM';
export const CHANGE_ACCOUNT_TYPE = 'CHANGE_ACCOUNT_TYPE';

export interface Preferences {
  notification?: boolean;
  mealInvisibleMessage?: boolean;
}

export interface Faqs {
  title: string;
  description: string;
}

export interface Settings {
  terms: string;
  termscz: string;
  termsit: string;
  aboutus: string;
  faqs: Faqs[];
}

export interface Form {
  email: string;
  message: string;
}

export interface SettingsProps {
  preferences: Preferences;
  settings: Settings;
}

export interface GetPreferencesAction extends SettingsProps {
  type: typeof GET_PREFERENCES;
}

export interface SetPreferencesAction extends SettingsProps {
  type: typeof SET_PREFERENCES;
  preferences: Preferences;
}

export interface UpdatePreferencesAction extends SettingsProps {
  type: typeof UPDATE_PREFERENCES;
  preferences: Preferences;
}

export interface SetSettings extends SettingsProps {
  type: typeof SET_SETTINGS;
  settings: Settings;
}

export interface SendContactUsForm {
  type: typeof SEND_CONTACT_FORM;
  form: Form;
}

export interface ChangeAccountTypeAction extends SettingsProps {
  type: typeof CHANGE_ACCOUNT_TYPE;
}

export type SettingsActionTypes =
  | GetPreferencesAction
  | SetPreferencesAction
  | SetSettings
  | ChangeAccountTypeAction;
